module.exports = __webpack_public_path__ + "img/series_14.6bc2de92.png";